<ag-grid-angular
  #agGrid
  class="ag-theme-material"
  data-test-selector="cross-modal-grid"
  [rowData]="crossReferences"
  [columnDefs]="columnDefs"
  [gridOptions]="gridOptions"
  (gridReady)="onGridReady($event)"
>
</ag-grid-angular>
